export default {
  'pages.layouts.userLayout.title': '这是一个MDM协议管理系统平台',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.auth.success': '认证成功',
  'pages.adde.title': '设备注册',
  'pages.adde.subtitle': '继续完成工作账户的设备注册。',
  'pages.byod.title': '用户注册认证',
  'pages.byod.subtitle': '继续完成企业账号注册。',
  'pages.byod.context.missing': '缺少注册上下文，请回到系统设置重新开始。',
  'pages.byod.session.expired': '注册会话已过期，请回到系统设置重新开始。',
  'pages.byod.register.prompt':
    '当前未找到对应的托管 Apple ID，请先补全注册信息后继续。',
  'pages.byod.register.email-target':
    '验证码将发送到当前托管 Apple ID 邮箱：{email}。',
  'pages.byod.register.family-name': '姓',
  'pages.byod.register.family-name.required': '请输入姓。',
  'pages.byod.register.given-name': '名',
  'pages.byod.register.given-name.required': '请输入名。',
  'pages.byod.register.department': '部门',
  'pages.byod.register.department.required': '请输入部门。',
  'pages.byod.code.send': '发送邮件验证码',
  'pages.byod.code.send-success': '邮件验证码发送成功。',
  'pages.byod.code.send-failed': '邮件验证码发送失败。',
  'pages.byod.code.no-email': '当前没有可用于接收验证码的邮箱。',
  'pages.byod.code.invalid-email': '当前验证码接收邮箱格式不正确。',
  'pages.byod.code.mailbox-unavailable':
    '验证码发送失败：目标邮箱不存在或当前无法接收邮件。',
  'pages.byod.code.sent': '邮件验证码已发送至 {email}。',
  'pages.byod.code.resend-wait': '{seconds} 秒后可重发',
  'pages.byod.code.placeholder': '邮件验证码',
  'pages.byod.code.required': '请输入邮件验证码。',
  'pages.byod.code.invalidated': '注册信息已变更，请重新发送验证码。',
  'pages.byod.auth.failed': '认证失败，请稍后重试。',
  'pages.byod.auth.invalid-code': '验证码错误或已过期。',
  'pages.byod.auth.session-expired': '注册会话已过期，请回到系统设置重新开始。',
  'pages.byod.submit': '继续',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.otp.placeholder': '请输入 OTP 验证码',
  'pages.login.otp.required': '请输入 OTP 验证码！',
  'pages.login.otp.invalid': 'OTP 验证码必须是 6 位数字！',
  'pages.login.submit.otp': '验证',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'app.account.center.title': '企业用户管理',
  'app.account.center.description':
    '查看当前企业下的全部用户，并可禁用指定用户。',
  'app.account.center.current-business': '当前企业',
  'app.account.center.user-name': '用户名',
  'app.account.center.email': '邮箱',
  'app.account.center.email-required': '请输入邮箱',
  'app.account.center.email-invalid': '邮箱格式不正确',
  'app.account.center.email-placeholder': '请输入邮箱',
  'app.account.center.business-code': '企业编码',
  'app.account.center.otp-status': 'OTP 状态',
  'app.account.center.enabled': '已启用',
  'app.account.center.disabled': '未启用',
  'app.account.center.user-status': '用户状态',
  'app.account.center.status.normal': '正常',
  'app.account.center.status.disabled': '已禁用',
  'app.account.center.status.locked': '已锁定',
  'app.account.center.status.unknown': '未知状态',
  'app.account.center.create-time': '创建时间',
  'app.account.center.actions': '操作',
  'app.account.center.already-disabled': '已禁用',
  'app.account.center.disable-confirm-title': '确认禁用该用户？',
  'app.account.center.disable-confirm-description':
    '禁用后该用户将无法继续登录系统。',
  'app.account.center.confirm': '确认',
  'app.account.center.cancel': '取消',
  'app.account.center.disable-user': '禁用用户',
  'app.account.center.edit-email': '编辑邮箱',
  'app.account.center.disable-success': '用户已禁用',
  'app.account.center.disable-failed': '禁用用户失败',
  'app.account.center.update-email-success': '邮箱更新成功',
  'app.account.center.update-email-failed': '邮箱更新失败',
  'app.account.center.create-user': '新增用户',
  'app.account.center.create-success': '用户创建成功',
  'app.account.center.create-failed': '用户创建失败',
  'app.account.center.user-name-required': '请输入用户名',
  'app.account.center.user-name-placeholder': '请输入用户名',
  'app.account.center.password': '登录密码',
  'app.account.center.password-required': '请输入登录密码',
  'app.account.center.password-placeholder': '请输入登录密码',
  'app.account.center.password-rule':
    '8-20 位，包含大小写字母、数字和特殊字符 @$!%*?&',
  'app.account.center.confirm-password': '确认密码',
  'app.account.center.confirm-password-required': '请再次输入密码',
  'app.account.center.confirm-password-placeholder': '请再次输入密码',
  'app.account.center.confirm-password-mismatch': '两次输入的密码不一致',
  'app.settings.s3.title': 'S3 存储设置',
  'app.settings.s3.description':
    '配置当前企业的 S3 存储参数，并在保存前执行连接测试。',
  'app.settings.s3.endpoint': 'Endpoint',
  'app.settings.s3.region': 'Region',
  'app.settings.s3.bucket': 'Bucket',
  'app.settings.s3.key-prefix': 'Key Prefix',
  'app.settings.s3.access-key-id': 'Access Key ID',
  'app.settings.s3.secret-access-key': 'Secret Access Key',
  'app.settings.s3.force-path-style': 'Force Path Style',
  'app.settings.s3.endpoint-required': '请输入 Endpoint',
  'app.settings.s3.region-required': '请输入 Region',
  'app.settings.s3.bucket-required': '请输入 Bucket',
  'app.settings.s3.access-key-id-required': '请输入 Access Key ID',
  'app.settings.s3.secret-placeholder':
    '留空表示不修改已保存的 Secret Access Key',
  'app.settings.s3.secret-reuse':
    '当前已配置 Secret Access Key，留空会沿用已保存值。',
  'app.settings.s3.test-button': '测试连接',
  'app.settings.s3.save-button': '保存配置',
  'app.settings.s3.load-failed': '加载 S3 配置失败',
  'app.settings.s3.save-success': 'S3 配置保存成功',
  'app.settings.s3.save-failed': 'S3 配置保存失败',
  'app.settings.s3.test-success': 'S3 连接测试成功',
  'app.settings.s3.test-failed': 'S3 连接测试失败',
  'app.settings.smtp.title': 'SMTP 设置',
  'app.settings.smtp.description':
    '配置当前企业的 SMTP 参数。保存前必须先发送测试邮件并验证通过。',
  'app.settings.smtp.host': 'SMTP Host',
  'app.settings.smtp.port': 'SMTP Port',
  'app.settings.smtp.username': 'Username',
  'app.settings.smtp.password': 'Password',
  'app.settings.smtp.from-email': '发件邮箱',
  'app.settings.smtp.from-name': '发件人名称',
  'app.settings.smtp.security-mode': '加密方式',
  'app.settings.smtp.test-recipient': '测试收件人',
  'app.settings.smtp.host-required': '请输入 SMTP Host',
  'app.settings.smtp.port-required': '请输入 SMTP Port',
  'app.settings.smtp.port-invalid': 'SMTP Port 必须是 1-65535 的整数',
  'app.settings.smtp.username-required': '请输入用户名',
  'app.settings.smtp.password-required': '请输入 Password',
  'app.settings.smtp.from-email-required': '请输入发件邮箱',
  'app.settings.smtp.from-email-invalid': '发件邮箱格式不正确',
  'app.settings.smtp.from-name-required': '请输入发件人名称',
  'app.settings.smtp.security-mode-required': '请选择加密方式',
  'app.settings.smtp.test-recipient-required': '请输入测试收件人',
  'app.settings.smtp.test-recipient-invalid': '测试收件人邮箱格式不正确',
  'app.settings.smtp.password-placeholder': '留空表示不修改已保存的 Password',
  'app.settings.smtp.password-reuse':
    '当前已配置 Password，留空会沿用已保存值。',
  'app.settings.smtp.security-mode.none': '无加密',
  'app.settings.smtp.security-mode.starttls': 'STARTTLS',
  'app.settings.smtp.security-mode.ssl-tls': 'SSL/TLS',
  'app.settings.smtp.test-button': '发送测试邮件',
  'app.settings.smtp.save-button': '保存配置',
  'app.settings.smtp.load-failed': '加载 SMTP 配置失败',
  'app.settings.smtp.save-success': 'SMTP 配置保存成功',
  'app.settings.smtp.save-failed': 'SMTP 配置保存失败',
  'app.settings.smtp.test-success': 'SMTP 测试邮件发送成功',
  'app.settings.smtp.test-failed': 'SMTP 测试失败',
  'app.settings.smtp.save-disabled-hint':
    '请先对当前配置发送测试邮件并确认成功，之后才可保存。',
  'app.settings.smtp.retest-required': '配置已修改，请重新测试 SMTP 后再保存。',
  'app.settings.backup.title': '平台备份',
  'app.settings.backup.description':
    '手动备份当前企业数据到已配置的 S3 backup 目录。',
  'app.settings.backup.manual-button': '手动备份',
  'app.settings.backup.manual-success': '手动备份已完成',
  'app.settings.backup.manual-failed': '手动备份失败',
  'app.settings.backup.load-failed': '加载备份记录失败',
  'app.settings.backup.table.create-date': '备份时间',
  'app.settings.backup.table.status': '状态',
  'app.settings.backup.table.bucket': 'Bucket',
  'app.settings.backup.table.key': '对象 Key',
  'app.settings.backup.table.file-size': '文件大小',
  'app.settings.backup.table.table-count': '表数量',
  'app.settings.backup.table.row-count': '总行数',
  'app.settings.backup.table.message': '说明',
  'app.settings.backup.status.success': '成功',
  'app.settings.backup.status.failed': '失败',
  'app.business.managed-apple-id.title': 'Managed Apple ID 列表',
  'app.business.managed-apple-id.description':
    '查看当前企业下的 Managed Apple ID 镜像账号列表。',
  'app.business.managed-apple-id.load-failed': '加载 Managed Apple ID 列表失败',
  'app.business.managed-apple-id.table.name': '姓名',
  'app.business.managed-apple-id.table.family-name': '姓氏',
  'app.business.managed-apple-id.table.given-name': '名字',
  'app.business.managed-apple-id.table.preferred-username':
    'Preferred Username',
  'app.business.managed-apple-id.table.email': '邮箱',
  'app.business.managed-apple-id.table.email-verified': '邮箱验证状态',
  'app.business.managed-apple-id.table.department': '部门',
  'app.business.managed-apple-id.table.create-time': '创建时间',
  'app.business.managed-apple-id.email-verified.yes': '已验证',
  'app.business.managed-apple-id.email-verified.no': '未验证',
  'app.business.managed-apple-id.table.status': '状态',
  'app.business.managed-apple-id.table.actions': '操作',
  'app.business.managed-apple-id.status.normal': '正常',
  'app.business.managed-apple-id.status.disabled': '已禁用',
  'app.business.managed-apple-id.action.disable': '禁用',
  'app.business.managed-apple-id.action.enable': '启用',
  'app.business.managed-apple-id.disable-confirm-title': '确认禁用该账号？',
  'app.business.managed-apple-id.disable-confirm-description':
    '禁用后将通过 SSF 通知 Apple Business Manager。',
  'app.business.managed-apple-id.enable-confirm-title': '确认启用该账号？',
  'app.business.managed-apple-id.confirm': '确认',
  'app.business.managed-apple-id.cancel': '取消',
  'app.business.managed-apple-id.disable-success': '已禁用',
  'app.business.managed-apple-id.enable-success': '已启用',
  'app.business.managed-apple-id.status-change-failed': '状态更新失败',
  // ===== SSF 事件日志 =====
  'app.event.ssf-log.title': 'SSF 事件日志',
  'app.event.ssf-log.description':
    '查看 SSF（Shared Signals Framework）事件推送历史记录。',
  'app.event.ssf-log.load-failed': '加载 SSF 事件日志失败',
  'app.event.ssf-log.table.event-type': '事件类型',
  'app.event.ssf-log.table.target-email': '目标用户',
  'app.event.ssf-log.table.stream-id': 'Stream ID',
  'app.event.ssf-log.table.push-status': '推送状态',
  'app.event.ssf-log.table.http-status': 'HTTP 状态码',
  'app.event.ssf-log.table.detail': '详情',
  'app.event.ssf-log.table.created-at': '推送时间',
  'app.event.ssf-log.status.success': '成功',
  'app.event.ssf-log.status.failed': '失败',
  'app.event.ssf-log.detail.view': '查看',
  'app.event.ssf-log.detail.error': '错误信息',
  'app.event.ssf-log.detail.response': '响应内容',
  // ===== OIDC 应用管理 =====
  'app.oidc-apps.title': 'OIDC 应用管理',
  'app.oidc-apps.description':
    '管理当前租户下的 OIDC 客户端应用、允许回跳地址和 client secret。',
  'app.oidc-apps.create-button': '申请应用',
  'app.oidc-apps.load-failed': '加载 OIDC 应用列表失败',
  'app.oidc-apps.detail-load-failed': '加载应用详情失败',
  'app.oidc-apps.create-success': '应用创建成功',
  'app.oidc-apps.create-failed': '应用创建失败',
  'app.oidc-apps.status-change-failed': '应用状态更新失败',
  'app.oidc-apps.enabled': '应用已启用',
  'app.oidc-apps.disabled': '应用已禁用',
  'app.oidc-apps.delete-success': '应用已删除',
  'app.oidc-apps.delete-failed': '应用删除失败',
  'app.oidc-apps.col.app-name': '应用名称',
  'app.oidc-apps.col.status': '状态',
  'app.oidc-apps.col.redirect-count': '回跳地址数',
  'app.oidc-apps.col.secret-last4': 'Secret 后四位',
  'app.oidc-apps.col.secret-created-at': 'Secret 创建时间',
  'app.oidc-apps.col.created-at': '创建时间',
  'app.oidc-apps.col.actions': '操作',
  'app.oidc-apps.action.view': '查看',
  'app.oidc-apps.action.disable': '禁用',
  'app.oidc-apps.action.enable': '启用',
  'app.oidc-apps.action.delete': '删除',
  'app.oidc-apps.delete-confirm-title': '删除应用',
  'app.oidc-apps.delete-confirm-desc':
    '删除后应用不会再出现在默认列表中，且协议流会立即拒绝。',
  'app.oidc-apps.create-modal-title': '申请 OIDC 应用',
  'app.oidc-apps.create-ok': '创建',
  'app.oidc-apps.create-cancel': '取消',
  'app.oidc-apps.form.app-name': '应用名称',
  'app.oidc-apps.form.app-name-required': '请输入应用名称',
  'app.oidc-apps.form.app-name-placeholder': '例如：Apple Business Manager',
  'app.oidc-apps.form.redirect-uris': '允许回跳地址',
  'app.oidc-apps.form.redirect-uris-hint':
    '默认使用 Apple ABM ACS 回调地址；如果留空，创建时会自动回退到该地址。',
  'app.oidc-apps.form.redirect-remove': '删除',
  'app.oidc-apps.form.redirect-add': '添加回跳地址',
  'app.oidc-apps.detail-title': '应用详情',
  'app.oidc-apps.detail.app-name': '应用名称',
  'app.oidc-apps.detail.status': '状态',
  'app.oidc-apps.detail.auth-method': '认证方式',
  'app.oidc-apps.detail.secret-last4': 'Secret 后四位',
  'app.oidc-apps.detail.secret-created-at': 'Secret 创建时间',
  'app.oidc-apps.detail.redirect-uris': '允许回跳地址',
  'app.oidc-apps.secret-modal-title': '请立即保存 Client Secret',
  'app.oidc-apps.secret-modal-ok': '我已保存',
  'app.oidc-apps.secret-modal-warning':
    '这个 Client Secret 只会展示一次，关闭后无法再次查看。',
  // ===== OIDC 应用详情页 - 回跳地址管理 =====
  'app.oidc-apps.status.active': '启用',
  'app.oidc-apps.status.disabled': '禁用',
  'app.oidc-apps.status.deleted': '已删除',
  'app.oidc-apps.detail.basic-info': '基本信息',
  'app.oidc-apps.detail.client-id': 'Client ID',
  'app.oidc-apps.detail.secret-display': '****{last4}',
  'app.oidc-apps.detail.created-at': '创建时间',
  'app.oidc-apps.detail.redirect-uri-mgmt': '回跳地址管理',
  'app.oidc-apps.detail.add-redirect-uri': '添加回跳地址',
  'app.oidc-apps.detail.col.redirect-uri': '回跳地址',
  'app.oidc-apps.detail.col.created-at': '创建时间',
  'app.oidc-apps.detail.col.actions': '操作',
  'app.oidc-apps.detail.action.edit': '修改',
  'app.oidc-apps.detail.action.delete': '删除',
  'app.oidc-apps.detail.delete-confirm-title': '确认删除此回跳地址？',
  'app.oidc-apps.detail.delete-confirm-desc':
    '删除后使用该地址的授权请求将失败。',
  'app.oidc-apps.detail.delete-ok': '删除',
  'app.oidc-apps.detail.delete-cancel': '取消',
  'app.oidc-apps.detail.add-modal-title': '添加回跳地址',
  'app.oidc-apps.detail.edit-modal-title': '修改回跳地址',
  'app.oidc-apps.detail.form.redirect-uri': '回跳地址',
  'app.oidc-apps.detail.form.redirect-uri-required': '请输入回跳地址',
  'app.oidc-apps.detail.form.redirect-uri-https':
    '回跳地址必须以 https:// 开头',
  'app.oidc-apps.detail.form.redirect-uri-placeholder':
    'https://example.com/callback',
  'app.oidc-apps.detail.modal.add-ok': '添加',
  'app.oidc-apps.detail.modal.save-ok': '保存',
  'app.oidc-apps.detail.modal.cancel': '取消',
  'app.oidc-apps.detail.add-success': '回跳地址添加成功',
  'app.oidc-apps.detail.add-failed': '添加失败',
  'app.oidc-apps.detail.edit-success': '回跳地址修改成功',
  'app.oidc-apps.detail.edit-failed': '修改失败',
  'app.oidc-apps.detail.delete-success': '回跳地址已删除',
  'app.oidc-apps.detail.delete-failed': '删除失败',
  'app.oidc-apps.detail.default-title': 'OIDC 应用详情',
  'app.oidc-apps.action.manage-redirect-uris': '管理回跳地址',
  // ===== OIDC 应用列表页 - 硬编码文本 =====
  'app.oidc-apps.status-confirm-title': '确认{label}',
  'app.oidc-apps.status-confirm-content': '确定要{label}应用「{name}」吗？',
  'app.oidc-apps.status-updated': '已{label}',
  'app.oidc-apps.status-update-failed': '操作失败',
  'app.oidc-apps.delete-confirm-content':
    '确定要删除应用「{name}」吗？此操作不可恢复。',
  'app.oidc-apps.deleted': '已删除',
  'app.oidc-apps.create-modal-redirect-label': '回跳地址（每行一个）',
  'app.oidc-apps.create-modal-redirect-required': '请输入至少一个回跳地址',
  'app.oidc-apps.create-modal-redirect-https':
    '回跳地址必须以 https:// 开头：{uri}',
  'app.oidc-apps.secret-save-warning':
    '请妥善保存以下 Client Secret，关闭后将无法再次查看。',
  'app.oidc-apps.secret-close-button': '我已保存，关闭',
  'app.oidc-apps.total-count': '共 {total} 条',
  // ===== 设备列表 =====
  'app.device.tooltip.user-enrollment': '基于用户注册',
  'app.device.tooltip.legacy-enrollment': '旧设备注册',
  'app.device.search-serial': '搜索序列号',
  'app.device.profile-update-success': '配置文件更新成功',
  'app.device.profile-update-failed': '配置文件更新失败',
  'app.device.command-network-error': '网络请求失败。',
  'app.device.enrollment-profile.select-skip': '请选择跳过的设置步骤。',
  'app.device.enrollment-profile.org-magic': '输入组织代码',
  'app.device.enrollment-profile.department': '输入部门',
  'app.device.enrollment-profile.support-phone': '输入支持电话号码',
  'app.device.enrollment-profile.support-email': '输入支持邮箱地址',
  // ===== 安全设置 =====
  'app.security.password-strength.strong': '强',
  'app.security.password-strength.medium': '中',
  'app.security.password-strength.weak': '弱',
  'app.security.mfa.bound': '已绑定 OTP 设备，可使用动态验证码进行二次验证。',
  'app.security.mfa.unbound': '未绑定 MFA 设备，绑定后，可以进行二次确认。',
  // ===== 证书管理 =====
  'app.cert.apns-title': 'APNS 证书管理',
  'app.cert.domain-title': '域名证书管理',
  'app.cert.abm-title': 'ABM 证书管理',
  'app.cert.label.match': '证书与私钥匹配',
  'app.cert.label.create-date': '创建日期',
  'app.cert.label.expire-date': '过期日期',
  'app.cert.label.issuer': '签发者',
  'app.cert.label.subject': '使用者',
  'app.cert.label.remark': '备注',
  'app.cert.label.cert-code': '证书编码',
  'app.cert.upload-success': '证书上传成功！',
  'app.cert.upload-failed': '上传失败',
  'app.cert.info-desc': '查看管理企业的基本信息。',
  // ===== 企业信息 =====
  'app.business.info-title': '企业信息',
  'app.business.edit-title': '编辑企业设置',
  'app.business.save-success': '企业设置保存成功',
  'app.business.save-failed': '保存企业设置失败',
  'app.business.tooltip.system-allocation': '系统分配，该值不可修改。',
  'app.business.tooltip.current-domain': '当前域名，该值不可修改。',
  'app.business.tooltip.apns-locked': '上传 APNS 证书后，该值不可修改。',
  'app.business.request-cert-title': '企业证书申请信息',
  // ===== 注册设置 =====
  'app.enrollment.settings-saved': '注册设置保存成功。',
  'app.enrollment.fallback-synced': '后备发现配置同步成功。',
  'app.enrollment.fallback-sync-failed': '后备发现配置同步失败。',
  'app.enrollment.no-sync-message': '暂无同步信息。',
  'app.enrollment.sync-fallback-button': '同步后备发现配置',
  // ===== 仪表盘 =====
  'app.dashboard.device-status': '设备状态',
  'app.dashboard.message': '消息',
  'app.dashboard.event-queue': '事件队列',
  'app.dashboard.summary': '摘要',
  'app.dashboard.params': '参数',
  'app.dashboard.unread': '未读',
  // ===== 上传 / 资产 =====
  'app.upload.limit-one': '只允许上传一个文件。',
  'app.assets.copied': '已复制！',
  'app.assets.copy-failed': '复制失败',
  // ===== OIDC 交互 =====
  'app.oidc.interaction.tenant': '租户',
  'app.oidc.interaction.client': '客户端',
  'app.oidc.interaction.redirect-uri': '回调地址',
  'app.oidc.interaction.requested-scopes': '请求的 scopes',
  'app.oidc.interaction.effective-scopes': '生效的 scopes',
  'app.oidc.interaction.family-name': '姓',
  'app.oidc.interaction.given-name': '名',
  'app.oidc.interaction.department': '部门',
  'app.oidc.interaction.verification-code': '验证码',
  // ===== 登录 =====
  'app.login.title': 'AegisMDM 登录',
  // ===== 注册 =====
  'app.register.success': '注册成功！',
  // ===== 上传媒体 =====
  'app.upload-media.category': '分类',
  'app.upload-media.remark': '备注',
  'app.upload-media.image': '图片',
  'app.upload-media.select-file': '选择媒体文件',
  // ===== 企业标签页 =====
  'app.business.tab.base': '基础信息',
  'app.business.tab.request-cert': '证书请求',
  'app.business.tab.enrollment-settings': '注册设置',
  // ===== 证书标签页 =====
  'app.cert.tab.certificate': '证书',
  'app.cert.tab.discussion': '讨论',
  // ===== 注册页面 =====
  'app.register.title': '注册',
  'app.register.email-placeholder': '邮箱',
  'app.register.email-required': '请输入邮箱地址!',
  'app.register.email-invalid': '邮箱地址格式错误!',
  'app.register.password-placeholder': '至少6位密码，区分大小写',
  'app.register.password-required': '请输入密码!',
  'app.register.password-mismatch': '两次输入的密码不匹配!',
  'app.register.confirm-placeholder': '确认密码',
  'app.register.confirm-required': '确认密码',
  'app.register.mobile-placeholder': '手机号',
  'app.register.mobile-required': '请输入手机号!',
  'app.register.mobile-invalid': '手机号格式错误!',
  'app.register.captcha-placeholder': '验证码',
  'app.register.captcha-required': '请输入验证码!',
  'app.register.get-captcha': '获取验证码',
  'app.register.submit': '注册',
  'app.register.login-link': '使用已有账户登录',
  'app.register.strength-strong': '强度：强',
  'app.register.strength-medium': '强度：中',
  'app.register.strength-weak': '强度：太短',
  'app.register.password-hint':
    '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  // ===== OIDC 交互标签 =====
  'app.oidc.interaction.label.tenant': '租户',
  'app.oidc.interaction.label.client': '客户端',
  'app.oidc.interaction.label.redirect-uri': '回调地址',
  'app.oidc.interaction.label.requested-scopes': '请求的 scopes',
  'app.oidc.interaction.label.effective-scopes': '生效的 scopes',
  'app.oidc.interaction.placeholder.family-name': '姓',
  'app.oidc.interaction.placeholder.given-name': '名',
  'app.oidc.interaction.placeholder.department': '部门',
  'app.oidc.interaction.placeholder.verification-code': '验证码',

  // ===== Certificate Discussion =====
  'app.cert.discussion.title.timeline': '证书申请流程',
  'app.cert.discussion.timeline.domain': '申请域名证书 [系统支持自动化操作]',
  'app.cert.discussion.timeline.mdm': '申请 MDM 供应商证书',
  'app.cert.discussion.timeline.apns': '申请 APNs 推送证书',
  'app.cert.discussion.timeline.abm': '申请 ABM 服务器令牌',
  'app.cert.discussion.title.domain': '1. 域名证书 (TLS/SSL)',
  'app.cert.discussion.content.domain':
    "**域名证书 (TLS/SSL)** 用于保障苹果设备与 Aegis MDM 系统之间通信的安全性。苹果要求所有 MDM 通信必须通过受信任的证书进行 HTTPS 加密。\n\n- **自动模式**：系统可通过 Let's Encrypt / ACME 协议自动申请并管理。\n- **手动模式**：您可以从受信任的证书机构（CA）购买 TLS/SSL 证书，并手动上传私钥（`.key`）和完整证书链（`.crt` 或 `.pem`）。",
  'app.cert.discussion.title.mdm': '2. MDM 供应商证书',
  'app.cert.discussion.content.mdm':
    '**MDM 供应商证书** 是生成下一步 APNs 推送证书的必要前置条件。您需要先从系统下载证书签名请求 (CSR) 文件，前往苹果开发者后台上传该文件并获取 MDM 证书。\n\n1. 登录 Apple Developer 后台 (https://developer.apple.com/account)，进入 Certificates, IDs & Profiles 部分。\n2. 点击 *Certificates* 旁边的加号 (+)。\n3. 在 *Services* 区域选择 *MDM CSR*，点击 *Continue*。\n4. 上传下载的 `VendorCertificateRequest.csr` 文件，点击 *Continue*。\n5. 点击 *Download* 下载生成的证书（通常名为 `mdm.cer`）。\n6. 将该 MDM 证书上传回本系统，以便对最终的 Push CSR 进行签名。',
  'app.cert.discussion.title.apns': '3. APNs 推送证书',
  'app.cert.discussion.content.apns':
    '**APNs (Apple Push Notification service) 推送证书** 用于向设备发送唤醒通知，提示设备主动与 MDM 服务器通信。\n\n1. 首先从 Aegis MDM 系统下载已签名的 **Push CSR**（内含上一步的 MDM 供应商证书签名信息）。\n2. 访问 Apple Push Certificates Portal (https://identity.apple.com/pushcert/) 并使用您的管理式 Apple ID 登录。\n3. 点击 *Create a Certificate*。\n4. 阅读并同意使用条款，然后上传刚才下载的 Push CSR 文件。\n5. 点击 *Upload*，然后 *Download* 生成的 APNs 证书（`.pem` 文件）。\n6. 将此 APNs 证书上传至 Aegis MDM 系统，开启设备推送功能。',
  'app.cert.discussion.title.abm': '4. ABM 服务器令牌',
  'app.cert.discussion.content.abm':
    '**ABM (Apple Business Manager) 服务器令牌** 用于建立您的 Aegis MDM 服务器与 Apple Business Manager 之间的信任，允许系统同步设备并使用自动设备注册 (ADE) 功能。\n\n1. 从 Aegis MDM 系统下载 **MDM 服务器公钥** (`.pem` 或 `.crt`)。\n2. 登录 Apple Business Manager (https://business.apple.com)。\n3. 点击左下角的个人资料名称，选择 *Preferences (偏好设置)*，并进入 *Your MDM Servers (您的 MDM 服务器)*。\n4. 点击 *Add MDM Server (添加 MDM 服务器)*，输入服务器名称，并上传在步骤 1 中下载的公钥。\n5. 保存服务器后，点击 *Download Token (下载令牌)* 来获取 MDM 服务器令牌 (`.p7m` 或 `.vpptoken` 文件)。\n6. 将此服务器令牌上传至 Aegis MDM 系统，完成 ABM 集成。',
};
